<template>
  <v-container grid-list-xl class="pa-0">
    <div wrap v-if="page">
      <m-card-list
        two-line
        title="Daftar Organisasi"
        :items="items"
        :headers="headers"
        refresh
        select
        filterAktivasi
        @refresh="load"
        @filter="load"
        :page="page"
        footer
        @search="
            search => {
              textSearch = search;
              load();
            }
          "
        @change:page="
            pg => {
              cp = pg;
              load();
            }
          "
        @add="add"
      >
        <template v-slot:items="{ props, item }">
          <tr v-if="$vuetify.breakpoint.smAndUp">
            <td>
              <v-avatar :size="40" color="grey lighten-4">
                <v-icon>mdi-office-building</v-icon>
              </v-avatar>
              {{ pVal(item, "nama") }}
            </td>
            <td>
              <v-chip
                v-if="item && item.is_aktivasi"
                outlined
                :color="item.is_aktivasi ? 'success' : 'grey'"
              >{{ item.is_aktivasi ? "Aktif" : "Belum Aktif" }}</v-chip
              >
            </td>
            <td>
              {{ item && item.jml_aktif || 0 }}
            </td>
            <td>
              {{ item && item.total_kuota || 0 }}
            </td>
            <td>
              {{ (item.total_kuota || 0) - (item.jml_aktif || 0) }}
            </td>
          </tr>
          <tr v-else>
            <td class="v-data-table__mobile-row">
              <div class="v-data-table__mobile-row__header mr-2">
                {{ headers[0].text }}
              </div>
              <div class="v-data-table__mobile-row__cell">
                {{ pVal(item, "nama") }}
              </div>
            </td>
            <td class="v-data-table__mobile-row">
              <div class="v-data-table__mobile-row__header mr-2">Status</div>
              <div class="v-data-table__mobile-row__cell">
                <v-chip
                  v-if="item && item.is_aktivasi"
                  outlined
                  :color="item.is_aktivasi ? 'success' : 'error'"
                >{{ item.is_aktivasi ? "Aktif" : "Tidak Aktif" }}</v-chip
                >
              </div>
            </td>
            <td class="v-data-table__mobile-row">
              <div class="v-data-table__mobile-row__header mr-2">User Aktivasi</div>
              <div class="v-data-table__mobile-row__cell">
                {{ item && item.jml_aktif || 0 }}
              </div>
            </td>
            <td class="v-data-table__mobile-row">
              <div class="v-data-table__mobile-row__header mr-2">Total Kuota</div>
              <div class="v-data-table__mobile-row__cell">
                {{ item && item.total_kuota || 0 }}
              </div>
            </td>
            <td class="v-data-table__mobile-row">
              <div class="v-data-table__mobile-row__header mr-2">Sisa Kuota</div>
              <div class="v-data-table__mobile-row__cell">
                {{ (item.total_kuota || 0) - (item.jml_aktif || 0) }}
              </div>
            </td>
          </tr>
        </template>
      </m-card-list>
    </div>
    <ChangeDlg ref="dlg" />
  </v-container>
</template>

<script>
import ChangeDlg from "../components/Form.vue";
import BlockCard from "@/components/BlockCard";

export default {
  components: {
    ChangeDlg,
    BlockCard
  },
  data() {
    return {
      items: [],
      page: null,
      textSearch: null,
      cp: 1,
      headers: [
        { text: "Nama", align: "left", value: "nama" },
        { text: "Status Aktivasi", align: "left", value: "is_Activate" },
        { text: "User Aktivasi", align: "left", value: "jml_aktif" },
        { text: "Total Kuota", align: "left", value: "total_kuota" },
        { text: "Sisa Kuota", align: "left", value: "sisa_kuota" }
      ]
    };
  },
  computed: {},
  mounted() {
    this.load();
  },
  methods: {
    load(data) {
      this.$store
        .dispatch("tenant/getAktivasi", {
          id_tenant: this.current_user.kode_tenant,
          params: {
            page: this.cp,
            keyword: this.textSearch,
            is_aktivasi: data ? data.statusAktivasi : null
          }
        })
        .then(res => {
          this.page = res.data;
          this.items = res.data.data;
        })
        .catch(e => e);
    },
    add() {
      this.$refs.dlg.open().then(() => {
        this.load();
      });
    },
    edit(item) {
      this.$refs.dlg.open(item).then(() => {
        this.load();
      });
    },
    search() {
      this.$router.push({
        name: "home"
      });
    },
    hapus(item) {
      this.$confirmDanger(
        `<div class="ma-1 mb-4 pa-1 row red lighten-4 red--text text--darken-4">

            <i class="ma-3 v-icon v-alert__icon mdi mdi-information-outline red--text text--darken-4"></i>

          <div class="col m11 pa-1">
          Anda juga akan menghapus seluruh anggota di organisasi ini!
          </div>
        </div>

        Apakah Anda yakin akan menghapus Organisasi ini ?<br>
        <div class="mt-2 title grow text-center">
          ${item.nama}<br>
        </div>

      `
      )
        .then(() =>
          this.$store.dispatch("organisasi/drop", item.kode_organisasi)
        )
        .then(() => {
          this.$info("Data organisasi berhasil dihapus");
        })
        .then(() => this.load())
        .catch(e => e);
    }
  }
};
</script>
